import script from "./DrawRule.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawRule.vue?vue&type=script&setup=true&lang=js"

import "./DrawRule.vue?vue&type=style&index=0&id=134e156d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134e156d"]])

export default __exports__